import React from 'react';

import EditorWidgetContent from './EditorWidgetContent/EditorWidgetContent';
import LiveSiteWidgetContent from './LiveSiteWidgetContent/LiveSiteWidgetContent';

const WidgetRoot = () => {
  const isEditorOrPreview =
    window.Wix.Utils.getViewMode() === 'editor' ||
    window.Wix.Utils.getViewMode() === 'preview';
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return <div />;
  }

  return (
    <>
      {isEditorOrPreview ? <EditorWidgetContent /> : <LiveSiteWidgetContent />}
    </>
  );
};

export default WidgetRoot;
